import React, { useState, useEffect } from 'react';
import './App.css';

function Auditoria() {
  const [fichajes, setFichajes] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  
  // Filtros
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [filtroEmpleado, setFiltroEmpleado] = useState('');

  // Estado para el modo edición
  const [fichajeEditando, setFichajeEditando] = useState(null);
  const [nuevaFechaHora, setNuevaFechaHora] = useState('');
  const [nuevoTipo, setNuevoTipo] = useState('');

  useEffect(() => {
    fetchDatos();
  }, []);

  const fetchDatos = async () => {
    try {
      const resEmp = await fetch('/api/empleados');
      const dataEmp = await resEmp.json();
      setEmpleados(dataEmp);

      const resFich = await fetch('/api/fichajes');
      const dataFich = await resFich.json();
      setFichajes(dataFich);
    } catch (error) {
      console.error('Error cargando datos:', error);
    }
  };

  const formatearFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleString('es-UY'); 
  };

  // Convertir fecha de la BD para el input datetime-local
  const formatearParaInput = (fechaISO) => {
    const fecha = new Date(fechaISO);
    // Ajuste de zona horaria básico para el input html
    fecha.setMinutes(fecha.getMinutes() - fecha.getTimezoneOffset());
    return fecha.toISOString().slice(0, 16);
  };

  const handleEliminar = async (id, nombre, tipo, fecha) => {
    const confirmacion = window.confirm(`ATENCIÓN: ¿Seguro que deseas ELIMINAR el fichaje de ${nombre} (${tipo} el ${formatearFecha(fecha)})?`);
    if (confirmacion) {
      try {
        const res = await fetch(`/api/fichajes/${id}`, { method: 'DELETE' });
        if (res.ok) {
          alert('Fichaje eliminado correctamente.');
          fetchDatos();
        }
      } catch (error) {
        console.error('Error al eliminar', error);
      }
    }
  };

  const iniciarEdicion = (fichaje) => {
    setFichajeEditando(fichaje.id);
    setNuevaFechaHora(formatearParaInput(fichaje.fecha_hora));
    setNuevoTipo(fichaje.tipo_fichaje);
  };

  const guardarEdicion = async (id) => {
    try {
      const res = await fetch(`/api/fichajes/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo_fichaje: nuevoTipo, fecha_hora: nuevaFechaHora })
      });

      if (res.ok) {
        alert('Fichaje actualizado con éxito.');
        setFichajeEditando(null);
        fetchDatos();
      } else {
        alert('Error al guardar la edición.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // Motor de filtrado
  const fichajesFiltrados = fichajes.filter(f => {
    let cumpleFecha = true;
    const fechaRegistro = new Date(f.fecha_hora);

    if (fechaInicio) {
      const inicio = new Date(fechaInicio); inicio.setHours(0,0,0,0);
      if (fechaRegistro < inicio) cumpleFecha = false;
    }
    if (fechaFin) {
      const fin = new Date(fechaFin); fin.setHours(23,59,59,999);
      if (fechaRegistro > fin) cumpleFecha = false;
    }

    let cumpleEmpleado = true;
    if (filtroEmpleado) {
      cumpleEmpleado = f.nombre === filtroEmpleado;
    }

    return cumpleFecha && cumpleEmpleado;
  });

  return (
    <div className="dashboard-pantalla">
      <header className="dashboard-header">
        <img src="/logo.png" alt="ASPE Logo" className="dashboard-logo" />
        <button onClick={() => window.location.href = '/dashboard'} className="btn-volver">Volver al Panel</button>
      </header>

      <main className="dashboard-main">
        <h2>🛠️ Auditoría de Tiempos</h2>
        <p>Modo Administrador: Corrija errores de fichaje, cambie horas o elimine registros incorrectos.</p>
        
        <div className="empleados-container" style={{ display: 'block' }}>
          {/* BARRA DE FILTROS */}
          <div className="filtros-bar" style={{ marginBottom: '20px' }}>
            <div className="filtro-grupo">
              <label>Desde:</label>
              <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
            </div>
            <div className="filtro-grupo">
              <label>Hasta:</label>
              <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
            </div>
            <div className="filtro-grupo" style={{ flex: 2 }}>
              <label>Filtrar por Empleado:</label>
              <select value={filtroEmpleado} onChange={(e) => setFiltroEmpleado(e.target.value)} style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc', width: '100%' }}>
                <option value="">-- Todos los empleados --</option>
                {empleados.map(emp => (
                  <option key={emp.id} value={emp.nombre}>{emp.nombre} ({emp.cargo})</option>
                ))}
              </select>
            </div>
          </div>

          <div className="empleados-lista">
            <h3>Registro Histórico Editable</h3>
            <table className="tabla-aspe">
              <thead>
                <tr>
                  <th>Empleado</th>
                  <th>Actividad</th>
                  <th>Fecha y Hora</th>
                  <th>Acciones Administrativas</th>
                </tr>
              </thead>
              <tbody>
                {fichajesFiltrados.map(registro => (
                  <tr key={registro.id}>
                    <td><strong>{registro.nombre}</strong><br/><small>{registro.cargo}</small></td>
                    
                    {/* COLUMNA ACTIVIDAD */}
                    <td>
                      {fichajeEditando === registro.id ? (
                        <select value={nuevoTipo} onChange={(e) => setNuevoTipo(e.target.value)} style={{ padding: '5px' }}>
                          <option value="Entrada">Entrada</option>
                          <option value="Inicio Descanso">Inicio Descanso</option>
                          <option value="Fin Descanso">Fin Descanso</option>
                          <option value="Salida">Salida</option>
                        </select>
                      ) : (
                        <span className={`badge-fichaje badge-${registro.tipo_fichaje.replace(' ', '-')}`}>
                          {registro.tipo_fichaje}
                        </span>
                      )}
                    </td>

                    {/* COLUMNA HORA */}
                    <td>
                      {fichajeEditando === registro.id ? (
                        <input 
                          type="datetime-local" 
                          value={nuevaFechaHora} 
                          onChange={(e) => setNuevaFechaHora(e.target.value)}
                          style={{ padding: '5px' }}
                        />
                      ) : (
                        formatearFecha(registro.fecha_hora)
                      )}
                    </td>

                    {/* COLUMNA ACCIONES */}
                    <td className="celda-acciones">
                      {fichajeEditando === registro.id ? (
                        <>
                          <button onClick={() => guardarEdicion(registro.id)} className="btn-accion" style={{ backgroundColor: '#28a745', color: 'white' }}>💾 Guardar</button>
                          <button onClick={() => setFichajeEditando(null)} className="btn-accion btn-peligro">❌ Cancelar</button>
                        </>
                      ) : (
                        <>
                          <button onClick={() => iniciarEdicion(registro)} className="btn-accion btn-editar">✏️ Editar</button>
                          <button onClick={() => handleEliminar(registro.id, registro.nombre, registro.tipo_fichaje, registro.fecha_hora)} className="btn-accion btn-borrar">🗑️ Borrar</button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Auditoria;